export const formatCurrency = (
  value: number,
  locale: string = 'en-US',
  currency: string = 'USD'
) => {
  if (isNaN(value)) return '';

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
};

export const formatPercentage = (value: number, locale: string = 'en-US') => {
  return new Intl.NumberFormat(locale, {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 3
  }).format(value);
};

export const snakeToKebab = (value: string): string =>
  value.replace(/_+/g, '-');

export const slugify = (value: string): string =>
  value
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/^(-+)|(-+)$/g, '');

export const stripUnrenderedPlaceholders = (value: string): string =>
  value
    .replace(/\{\{\s*([^{}]*?)\s*\}\}/g, '$1')
    .replace(/\s+/g, ' ')
    .trim();
